import { combineReducers } from 'redux';
import DashboardReducer from './DashboardReducer';

const rootReducer = combineReducers({
  dashboard_state: DashboardReducer,
});

export default rootReducer;
